import {compact} from '@benchling/js-utils';

import {ChipPopoverInfoField} from 'ui-library/chips/ChipPopoverContent';

import {GetChipPopoverContentsArgs} from '../ChipUtilConstants';
import {
  getIdField,
  getNameField,
  getStatusField,
  getStudiesField,
} from '../getDefaultProcessTaskChipPopoverContent';

export default function getProcedureRunChipPopoverFields({
  processTask,
  icon,
  procedureTemplateField,
}: GetChipPopoverContentsArgs & {procedureTemplateField: ChipPopoverInfoField}): Array<ChipPopoverInfoField> {
  return compact([
    getIdField(processTask),
    getNameField(processTask, icon),
    getStatusField(processTask),
    procedureTemplateField,
    getStudiesField(processTask),
  ]);
}
